import { render, staticRenderFns } from "./animalStatus.vue?vue&type=template&id=1955397a"
import script from "./animalStatus.vue?vue&type=script&lang=js"
export * from "./animalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports